"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  filled: {
    '&.MuiInputAdornment-positionStart&:not(.MuiInputAdornment-hiddenLabel)': {
      marginTop: 0
    }
  }
};
var _default = exports.default = {
  styleOverrides
};
//# sourceMappingURL=MuiInputAdornment.js.map